// Palette
export default {
  padding: {
    paddingTop: 0,
    paddingBottom: 0,
  }
};
